import {CANCEL_AJAX_REQUESTS} from '../../constants';
import {
    AppDispatch,
    StoreState,
    Thunk
} from '~/frontend/src/store';

export type CancelRequestsAction = {
    /**
     * The action type
     */
    type : typeof CANCEL_AJAX_REQUESTS;

    /**
     * The uid of the component the requests belongs to
     */
    componentUid : string;
}

/**
 * @memberOf! Actions
 *
 * @param {String} componentUid         The uid of the component the requests belongs to
 *
 * @return {CancelRequestsAction}
 */
const cancelRequests = ( componentUid : string ) : Thunk<boolean> => ( dispatch : AppDispatch, getState : () => StoreState ) : boolean => {
    const xhr  = getState()?.xhr,
          uids = Object.keys( xhr ) as string[];

    let retVal : boolean = false;

    for ( const uid of uids ) {
        if ( uid.indexOf( componentUid ) === 0 ) {
            retVal = true;

            dispatch( {
                type: CANCEL_AJAX_REQUESTS,
                componentUid: uid
            } );
        }
    }

    return retVal;
}
export type CancelRequests = typeof cancelRequests;

export default cancelRequests;
